"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThenConditionArgs = exports.ThenConditionModel = void 0;
class ThenConditionModel {
}
exports.ThenConditionModel = ThenConditionModel;
class ThenConditionArgs {
}
exports.ThenConditionArgs = ThenConditionArgs;
